import React from 'react';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import * as Icons from 'components/Icons'

const FooterItem = ({ icon, title, lead }) => {
    const Icon = Icons[icon];
    return (
        <Col className="footer__item p-0">
            <div className="footer__image">
                <Icon />
            </div>
            <div className="footer__content">
                <div className="footer__title">{title}</div>
                <div className="footer__lead" dangerouslySetInnerHTML={{ __html: lead }}></div>
            </div>
        </Col>
    );
};

FooterItem.propTypes = {
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    lead: PropTypes.string.isRequired,
};

export default FooterItem;
